import { api as generatedApi } from 'gen/rtk-openapi'

const TAG_TYPES = {
  finishedGoods: 'FinishedGoods',
  finishedGoodsMeta: 'FinishedGoodsMeta',
  packingList: 'PackingList',
  priceSheets: 'PriceSheets',
  inventoryCommodity: 'InventoryCommodity',
  inboundTickets: 'InboundTickets',
}

export const api = generatedApi.enhanceEndpoints({
  addTagTypes: [TAG_TYPES.finishedGoods, TAG_TYPES.finishedGoodsMeta],
  endpoints: {
    getFinishedGoods: {
      providesTags: result =>
        result && result.Items
          ? // successful query
            [
              ...result.Items.map(finishedGood => ({
                type: TAG_TYPES.finishedGoods,
                id: finishedGood.id,
              })),
              { type: TAG_TYPES.finishedGoods, id: 'LIST' },
            ]
          : // error occurred, refetch when `{ type: 'FinishedGoods', id: 'LIST' }` is invalidated
            [{ type: TAG_TYPES.finishedGoods, id: 'LIST' }],
    },
    getFinishedGoodById: {
      providesTags: (result, error, { id }) => [{ type: TAG_TYPES.finishedGoods, id }],
    },
    getFinishedGoodByTag: {
      providesTags: (result, error, { id }) => [{ type: TAG_TYPES.finishedGoods, id }],
    },
    createFinishedGood: {
      invalidatesTags: (result, error) => [
        { type: TAG_TYPES.finishedGoods, id: 'LIST' },
        { type: TAG_TYPES.packingList },
        { type: TAG_TYPES.priceSheets },
        { type: TAG_TYPES.inventoryCommodity },
        { type: TAG_TYPES.finishedGoodsMeta },
        { type: TAG_TYPES.inboundTickets, id: 'LIST' },
        { type: TAG_TYPES.inboundTickets },
        { type: TAG_TYPES.inboundTickets, id: result?.inboundTicketId },
      ],
    },
    updateFinishedGood: {
      invalidatesTags: (result, error, { finishedGoodsId }) => [
        { type: TAG_TYPES.finishedGoods, id: finishedGoodsId },
        { type: TAG_TYPES.packingList },
        { type: TAG_TYPES.priceSheets },
        { type: TAG_TYPES.inventoryCommodity },
        { type: TAG_TYPES.finishedGoodsMeta },
        { type: TAG_TYPES.inboundTickets, id: 'LIST' },
        { type: TAG_TYPES.inboundTickets, id: result?.inboundTicketId },
      ],
    },
    voidFinishedGood: {
      invalidatesTags: [
        { type: TAG_TYPES.finishedGoods, id: 'LIST' },
        { type: TAG_TYPES.packingList },
        { type: TAG_TYPES.priceSheets },
        { type: TAG_TYPES.inventoryCommodity },
        { type: TAG_TYPES.finishedGoodsMeta },
        { type: TAG_TYPES.inboundTickets, id: 'LIST' },
        { type: TAG_TYPES.inboundTickets },
      ],
    },
    getInventoryFinishedGoodList: {
      providesTags: result =>
        result && result.Items
          ? // successful query
            [
              ...result.Items.map(finishedGoodMeta => ({
                type: TAG_TYPES.finishedGoodsMeta,
                id: finishedGoodMeta.id,
              })),
              { type: TAG_TYPES.finishedGoodsMeta, id: 'LIST' },
            ]
          : // error occurred, refetch when `{ type: 'FinishedGoods', id: 'LIST' }` is invalidated
            [{ type: TAG_TYPES.finishedGoodsMeta, id: 'LIST' }],
    },
  },
})

export const groupFinishedGoodsByMaterial = finishedGoods =>
  finishedGoods.reduce((acc, finishedGood) => {
    const copy = { ...acc }
    const materialName = finishedGood?.materialName

    if (copy[materialName]) {
      copy[materialName] = [...copy[materialName], finishedGood]
    } else {
      copy[materialName] = [finishedGood]
    }

    return copy
  }, {})

export const useGetFinishedGoodByTagLazyQuery = api.endpoints.getFinishedGoodByTag.useLazyQuery

export const {
  useGetFinishedGoodsQuery,
  useGetFinishedGoodByIdQuery,
  useGetFinishedGoodByTagQuery,
  useCreateFinishedGoodMutation,
  useUpdateFinishedGoodMutation,
  useVoidFinishedGoodMutation,
  useGetInventoryFinishedGoodListQuery,
} = api
